import { render, staticRenderFns } from "./fleet_brand_modal.vue?vue&type=template&id=52bf8666"
import script from "./fleet_brand_modal.vue?vue&type=script&lang=js"
export * from "./fleet_brand_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports